import { useTranslation } from 'react-i18next';
import { useUIStore } from '@/stores/uiStore';

interface ArtifactTagProps {
  type:
    | 'html'
    | 'jsx'
    | 'react'
    | 'text'
    | 'markdown'
    | 'mermaid'
    | 'svg'
    | 'code'
    | 'isolated-html';
  content: string;
  title: string;
  language?: string;
}

/**
 * ArtifactTag 组件
 * 在消息中显示可点击的标签，点击后在右侧分屏显示内容
 * 样式参考 Claude 的 artifact 卡片设计
 */
export default function ArtifactTag({
  type,
  content,
  title,
  language,
}: ArtifactTagProps) {
  const { t } = useTranslation();
  const { setArtifactViewer, setFilePreview } = useUIStore();

  const handleClick = () => {
    // 🔥 打开 Artifact 时关闭文件预览（互斥）
    setFilePreview(null);
    setArtifactViewer({
      type,
      content,
      title,
      language,
    });
  };

  const typeLabels: Record<string, string> = {
    html: t('artifact.interactiveArtifact'),
    jsx: t('artifact.interactiveArtifact'),
    react: t('artifact.interactiveArtifact'),
    text: t('artifact.textContent'),
    markdown: t('artifact.markdownDocument'),
    mermaid: t('artifact.diagram'),
    svg: t('artifact.svgImage'),
    code: language
      ? t('artifact.codeWithLanguage', { language: language.toUpperCase() })
      : t('artifact.code'),
    'isolated-html': t('artifact.isolatedHtml'),
  };

  return (
    <div className="my-3 max-w-2xl">
      <button
        onClick={handleClick}
        className="w-full text-left bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-lg p-4 transition-colors duration-200 group"
        title={t('tooltips.clickToPreview')}
      >
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1 min-w-0">
            <h3 className="text-base font-medium text-gray-900 mb-1 truncate">
              {title}
            </h3>
            <p className="text-sm text-gray-500">{typeLabels[type]}</p>
          </div>
        </div>
      </button>
    </div>
  );
}
